import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SwitcherOutlinedSvg from "@ant-design/icons-svg/es/asn/SwitcherOutlined";
import AntdIcon from "../components/AntdIcon";
var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwitcherOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SwitcherOutlined.displayName = 'SwitcherOutlined';
}
export default /*#__PURE__*/React.forwardRef(SwitcherOutlined);